/* ---------------------------------------
   Helpers
--------------------------------------- */

/*
  Delivery estimate, measured rather than guessed.

  Rewritten 2026-09-26 from 89 real orders delivered between 30 Aug and
  26 Sept 2026, timed order-placed to Delhivery's own DELIVERED scan:

    order -> delivered   median 5.2 days   p75 6.3   p90 7.9   max 12.8
    order -> dispatch    median 1.6 days   p90 3.6            (ours)
    dispatch -> delivered median 3.2 days  p90 6.0            (Delhivery)

  The previous copy promised 3-5 days and was right 41.6% of the time.
  40% of orders landed in 5-7 days and 18% took over a week, so the page
  was setting up nearly six customers in ten to be disappointed and to
  write in asking where their parcel was.

  Pincodes beginning with 6 are Tamil Nadu, Kerala and Puducherry, which
  is where roughly nine in ten Derby orders go and where the measured
  median is 5.1 days with a 90th percentile of 7.0. Everywhere else ran
  7.1 to 8.6 days, so it gets a wider window.

  These are calendar days from the order being placed, which is what the
  customer actually experiences. Quoting transit time alone would hide
  the dispatch leg, and the dispatch leg is where the variance lives.

  1 Oct 2026 (Maison redesign): emoji removed from every message. The
  messages carry a small line icon from CSS instead (.msg::before).
*/
function getEtaWindow(pincode) {
  var south = typeof pincode === 'string' && pincode.charAt(0) === '6';
  return south ? { min: 5, max: 7 } : { min: 7, max: 10 };
}

function getRangeEta(minDays, maxDays) {
  if (minDays === undefined) { minDays = 5; }
  if (maxDays === undefined) { maxDays = 7; }

  var start = new Date();
  start.setDate(start.getDate() + minDays);

  var end = new Date();
  end.setDate(end.getDate() + maxDays);

  var opts = { weekday: 'short', month: 'short', day: 'numeric' };

  return 'Arriving ' +
         start.toLocaleDateString('en-IN', opts) +
         ' – ' +
         end.toLocaleDateString('en-IN', opts);
}

/* ---------------------------------------
   Input Handler (numbers only + button toggle)
--------------------------------------- */
function handlePincodeInput(input) {
  input.value = input.value.replace(/\D/g, '');

  var button = document.getElementById('pincode-action-btn');
  button.disabled = input.value.length === 0 || input.disabled;
}

/* ---------------------------------------
   Button Toggle
--------------------------------------- */
function handlePincodeAction() {
  var btn = document.getElementById('pincode-action-btn');
  btn.innerText === 'Check' ? checkDeliveryPincode() : resetPincode();
}

function resetPincode() {
  var input = document.getElementById('delivery-pincode');
  var button = document.getElementById('pincode-action-btn');

  input.disabled = false;
  input.value = '';
  input.focus();

  button.innerText = 'Check';
  button.disabled = true;

  ['delivery-msg', 'cod-msg', 'return-msg'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) { el.style.display = 'none'; }
  });
}

/* ---------------------------------------
   Main Logic
--------------------------------------- */
async function checkDeliveryPincode() {
  const wrapper = document.querySelector('.delivery-options');
  const nonServiceable = JSON.parse(wrapper.dataset.nonServiceable);
  const nonCOD = JSON.parse(wrapper.dataset.nonCod);

  const input = document.getElementById('delivery-pincode');
  const btn = document.getElementById('pincode-action-btn');
  const deliveryMsg = document.getElementById('delivery-msg');
  const codMsg = document.getElementById('cod-msg');
  const returnMsg = document.getElementById('return-msg');

  const pincode = input.value.trim();

  /* Regex validation */
  if (!/^[1-9][0-9]{5}$/.test(pincode)) {
    deliveryMsg.innerHTML = 'Please enter a valid 6-digit pincode';
    deliveryMsg.className = 'msg error';
    deliveryMsg.style.display = 'block';
    return;
  }

  /* Non-serviceable */
  if (nonServiceable.includes(pincode)) {
    deliveryMsg.innerHTML = 'Delivery is not available at this pincode';
    deliveryMsg.className = 'msg error';
    deliveryMsg.style.display = 'block';
    return;
  }

  /* India Post API validation */
  let apiResponse = null;

  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    apiResponse = await res.json();
  } catch (e) {}

  if (!apiResponse || apiResponse[0]?.Status !== 'Success') {
    deliveryMsg.innerHTML = 'Please enter a valid 6-digit pincode';
    deliveryMsg.className = 'msg error';
    deliveryMsg.style.display = 'block';
    codMsg.style.display = 'none';
    returnMsg.style.display = 'none';
    return;
  }

  /* Success */
  const eta = getEtaWindow(pincode);
  deliveryMsg.innerHTML = getRangeEta(eta.min, eta.max);
  deliveryMsg.className = 'msg success msg--eta';
  deliveryMsg.style.display = 'block';

  codMsg.innerHTML = nonCOD.includes(pincode)
    ? 'Cash on delivery is not available'
    : 'Cash on delivery is available';

  codMsg.className = nonCOD.includes(pincode) ? 'msg error' : 'msg success msg--cod';
  codMsg.style.display = 'block';

  returnMsg.style.display = 'block';

  /* Lock */
  input.disabled = true;
  btn.innerText = 'Change';
  btn.disabled = false;
}
